import { TableRowType } from 'src/types/table';

/** Sestaví Labelary URL pro jeden EAN + SKU (štítek s čárovým kódem). */
export const createEanLabelUrl = (sku: string, ean: string): string => {
    const value = String(ean || '').trim();
    return `http://api.labelary.com/v1/printers/8dpmm/labels/4x3/0/^XA^CF0,40^FO70,100^FDSKU: ${sku}^FS^BY${
        value && value.length > 20 ? 2 : 3
    },1,130^FO30,270^BC^FD${value}^FS^XZ`;
};

/** Aktivní EANy produktu — z EANS (i když jen inactive → []), legacy `EAN` jen bez EANS. */
export const getActiveEansFromProduct = (product: TableRowType): string[] => {
    const eans = product.EANS as Array<{ ean: string; active: boolean }> | undefined;
    if (Array.isArray(eans)) {
        return eans
            .filter((e) => e.active)
            .map((e) => String(e.ean || '').trim())
            .filter((ean) => ean && !ean.includes(','));
    }
    if (!product.EAN) {
        return [];
    }
    return String(product.EAN)
        .split(',')
        .map((part) => part.trim())
        .filter(Boolean);
};

const createEanLink = (product: TableRowType): string => {
    const eans = getActiveEansFromProduct(product);
    return createEanLabelUrl(String(product.SKU || ''), eans[0] || '');
};

export default createEanLink;
